import "../Styles/navbar.css"
import {Link} from "react-scroll"

import cv from "./Chinta-Sivanaryana-Resume.pdf"

function Navtop() {

    return <>
        {/* <div id="navcontainer" style={{ display: "flex", justifyContent: "space-around" }}>
            <div id="myname">
                <p>Chinta Sivanaryana</p>
            </div>
            <div id="details">
                <p className="detail">Home</p>
                <p className="detail">Contect</p>
                <p className="detail">Skills</p>
                <p className="detail">Projects</p>
            </div>

        </div> */}
        <div className="n-wrapper">
            <div className="n-left">
                <div className="n-name" >
                    {/* <img src="https://i.ibb.co/cFrrsb4/output-onlinegiftools.gif" alt="output-onlinegiftools" alt="siva" /> */}
                    <Link to={"home"} smooth duration={1000} > <p style={{"fontFamily":"greatvibe"}}> Siva</p> </Link>
                </div>
                {/* <span id="t">toggle</span> */}
            </div>
            <div className="n-right">
                <div className="n-list">
                    <ul style={{ listStyleType: "none",color:"white" }}>
                        <Link to={"home"} smooth duration={1000} >{"Home"}</Link>
                        <Link to={"home"} smooth duration={1000} >{"About"}</Link>
                        <Link to={"skills"} smooth duration={1000}>{"Skills"}</Link>
                        <Link to={"projects"} smooth duration={1000}>{"Projects"}</Link>
                        <Link to={"github"} smooth duration={1000}>{"Github"}</Link>
                        <Link to={"contacts"} smooth duration={1000}>{"Contact"}</Link>
                        <a href={cv} smooth="true" onClick={()=>window.open("https://drive.google.com/file/d/1y6IF4HG_ykfG52FxvKLQfMO4h5qulomj/view?usp=share_link")}
            download={'Chinta-Sivanarayana-Resume.pdf'} textDecoration='null' target="_blank" rel="noreferrer"
          >
            <button >Resume</button>
          </a>
                    </ul>
                </div>
                {/* <button className="button"></button> */}
            </div>
        </div>
    </>
}
export default Navtop